import { EBlankFormStatus } from '../enums/blank_form.enum';

export interface IBlankFormStatusHistory {
  id: number;
  action: EBlankFormStatus;
  blankFormId: number;
  createdAt: string;
  createdBy: string;
  data: { reason: string };
  deletedAt: string;
  deletedBy: string;
  state: string;
  updatedAt: string;
}
